import React from "react";
import { AccommodationEventType, EventLog_AccommodationEventFragment } from "@graphql";
import { Event } from "../../Event/Event";
import { AccommodationEventFloatingMenu } from "../AccommodationEventFloatingMenu/AccommodationEventFloatingMenu";
import { InlineEditor } from "@components/InlineEditor/InlineEditor";
import { AccommodationEventLogStore } from "../AccommodationEventLogStore";
import { StyledHtml } from "@common/StyledHtml";
import { Link } from "@material-ui/core";
import { OpenInNew } from "@material-ui/icons";

type Props = {
  item: EventLog_AccommodationEventFragment;
  store: AccommodationEventLogStore;
};

export function AccommodationEvent(props: Props) {
  const [editing, setEditing] = React.useState(false);
  const { item } = props;

  const icon = eventTypeToIcon[item.Type]?.() ?? null;
  const menu = (
    <AccommodationEventFloatingMenu event={item} onEdit={() => setEditing(true)} />
  );
  const description = item.Description;

  return (
    <Event item={item} icon={icon} floatingMenu={menu}>
      {description && (
        <InlineEditor
          readOnlyRenderer={() => (
            <>
              <StyledHtml styleProps={{ display: "inline-block" }}>
                {item.DescriptionHtml}
              </StyledHtml>
              {item.Links &&
                item.Links.map((url, i) => (
                  <Link
                    key={i}
                    href={url}
                    target="_blank"
                    style={{
                      display: "inline-block",
                      verticalAlign: "bottom",
                      padding: "0 4px",
                      lineHeight: 1
                    }}
                  >
                    <OpenInNew />
                  </Link>
                ))}
            </>
          )}
          initialValue={description}
          isEditing={editing}
          onCancel={() => setEditing(false)}
          onSubmit={(text) =>
            props.store.updateEvent(item._id, text).then(() => setEditing(false))
          }
        />
      )}
    </Event>
  );
}

const eventTypeToIcon: Record<AccommodationEventType, () => React.ReactNode | null> = {
  [AccommodationEventType.Comment]: () => null,
  [AccommodationEventType.SystemLog]: () => null
};
